import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Open/closed gate for authenticated API calls (see token-refresh.interceptor.ts).
 * Closed from page load until the websocket has connected and the token has been replaced
 * (WebSocketService), so no authenticated call goes out with a token that is about to change.
 */
@Injectable({ providedIn: 'root' })
export class ConnectionGateService {
  private readySubject = new BehaviorSubject<boolean>(false);
  readonly ready$ = this.readySubject.asObservable();

  get isReady(): boolean {
    return this.readySubject.value;
  }

  open(): void {
    this.readySubject.next(true);
  }

  close(): void {
    this.readySubject.next(false);
  }
}
